import React from "react";
import { Grid2 } from "@mui/material";
// styles
import styles from "./NewRoconCard.module.scss";

export default function NewRoconCard({ header, icon, onClick }) {
  return (
    <Grid2 className={styles.NewRoconCardContainer}>
      <img src={icon} alt="Card Icon" className={styles.icon} />
      <Grid2 className={styles.header}>{header}</Grid2>
      <Grid2 className={styles.title} onClick={onClick}>
        Read more
      </Grid2>
    </Grid2>
  );
}
